import { apiClient } from '../services/api'

/**
 * Runtime auth configuration fetched from the API (`GET /api/auth/config`),
 * so the SPA does not need a rebuild to change Entra tenant/client IDs.
 */
export interface AuthRuntimeConfig {
  authEnabled: boolean
  tenantId: string
  spaClientId: string
  apiClientId: string
  apiScope: string
  authority: string
  /** Full URL to this project in DevAssist. Empty/absent when unconfigured. */
  devassistProjectUrl?: string
}

let cached: AuthRuntimeConfig | null = null

export async function loadAuthConfig(): Promise<AuthRuntimeConfig> {
  if (cached) return cached
  try {
    const { data } = await apiClient.get<AuthRuntimeConfig>('/auth/config')
    cached = data
  } catch {
    // If the API is unreachable, disable auth so the demo/attendee UI still runs.
    cached = {
      authEnabled: false,
      tenantId: '',
      spaClientId: '',
      apiClientId: '',
      apiScope: '',
      authority: '',
      devassistProjectUrl: '',
    }
  }
  return cached
}
